import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=ddf9cc20&scoped=true&"
import script from "./TableBox.vue?vue&type=script&lang=js&"
export * from "./TableBox.vue?vue&type=script&lang=js&"
import style0 from "./TableBox.vue?vue&type=style&index=0&id=ddf9cc20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf9cc20",
  null
  
)

export default component.exports